import React from "react";
import SiteLayout from "../../components/layout/SiteLayout";
import PageIntro from "../../components/ui/PageIntro";

export default class CalendarPage extends React.Component {
  render() {
    return (
      <SiteLayout>
        <main className="page-shell home-v3-shell">
          <PageIntro
            eyebrow="Calendar"
            title="Keep the dates in view."
            description="Observances, ceremonies, and planned events in one place, so upcoming dates are easy to find."
          />

          <section className="section">
            <div className="home-v3-band-label">
              <span className="home-v3-kicker">Schedule</span>
              <h2>Upcoming dates I track.</h2>
              <p>
                I use the embedded calendar to track ceremonies, observances,
                and planned events in one place.
              </p>
            </div>
            <div className="home-v3-panel" style={{ overflow: "hidden" }}>
              <iframe
                src="https://calendar.google.com/calendar/embed?src=n2k8rc3insqp26g7t9vkpkq2pg%40group.calendar.google.com&amp;ctz=America%2FNew_York"
                style={{ border: 0, width: "100%", height: "100vh", display: "block" }}
                frameBorder="0"
                scrolling="no"
                title="Google Calendar"
              />
            </div>
          </section>
        </main>
      </SiteLayout>
    );
  }
}
